export { default } from './VideoBox';



// WEBPACK FOOTER //
// ./src/components/molecules/VideoBox/index.js